/* eslint-disable react/prop-types */
import React, { FunctionComponent } from "react";
import { Link } from "wouter";

import { config } from "../../config/config";
import { useHomeLink } from "../../navigation/useHomeLink";
import { useNullableDealerAccountInfo } from "../../stores/hooks/useNullableDealerAccountInfo";
import { useNullableGroupAccountInfo } from "../../stores/hooks/useNullableGroupAccountInfo";
import { useNullableNationalAccountInfo } from "../../stores/hooks/useNullableNationalAccountInfo";
import { useSearchForm } from "../../stores/hooks/useSearchForm";
import { PricingAnalysisModal } from "../PricingAnalysis/PricingAnalysisModal";
import { Actions } from "./Actions";
import { DealerName } from "./DealerName";
import { Nav } from "./Nav";
import { Sidebar } from "./Sidebar/Sidebar";

export const Header: FunctionComponent = () => {
  const dealer = useNullableDealerAccountInfo();
  const group = useNullableGroupAccountInfo();
  const national = useNullableNationalAccountInfo();
  const [, { reset }] = useSearchForm();
  const homeLink = useHomeLink();
  const { HeaderAddons, Logo, NationalDescriptor } = config;
  return (
    <header className="tw-header z-20">
      <div className="tw-header__container">
        <Sidebar />
        {!group && (
          <Link onClick={reset} to={homeLink}>
            <a className="tw-header__logo">
              <Logo />
            </a>
          </Link>
        )}
        {dealer && <DealerName>{dealer.dealerName}</DealerName>}
        {group && <DealerName>{group.dealerGroupName}</DealerName>}
        {national && NationalDescriptor && (
          <DealerName>
            <NationalDescriptor />
          </DealerName>
        )}
        <HeaderAddons />
        <div className="tw-header__controls">
          <Nav />
          {dealer && <Actions />}
        </div>
      </div>
      <PricingAnalysisModal />
    </header>
  );
};
